/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ reason: NonNullable<unknown> }} Task_Decline_Reason_NameInputs */

const en_task_decline_reason_name = /** @type {(inputs: Task_Decline_Reason_NameInputs) => LocalizedString} */ (i) => {
	if (i?.reason === "prior_agreement_or_payment") return /** @type {LocalizedString} */ (`Agreement or payment made previously`);
	if (i?.reason === "no_collection_standing") return /** @type {LocalizedString} */ (`No legal standing to collect`);
	if (i?.reason === "no_causal_link") return /** @type {LocalizedString} */ (`No causal link`);
	if (i?.reason === "concurrent_fault_uncollectible") return /** @type {LocalizedString} */ (`Concurrent fault`);
	if (i?.reason === "claimant_sole_fault") return /** @type {LocalizedString} */ (`Claimant at fault`);
	if (i?.reason === "inconclusive_accident_dynamics") return /** @type {LocalizedString} */ (`Inconclusive accident dynamics`);
	if (i?.reason === "insufficient_documentation") return /** @type {LocalizedString} */ (`Insufficient documentation`);
	if (i?.reason === "unproven_damages_or_amounts") return /** @type {LocalizedString} */ (`Unable to prove the claimed damages or amounts`);
	if (i?.reason === "time_barred") return /** @type {LocalizedString} */ (`Statute of limitations expired`);
	if (i?.reason === "third_party_liability_unproven") return /** @type {LocalizedString} */ (`Third-party liability unproven`);
	if (i?.reason === "responsible_party_unidentified") return /** @type {LocalizedString} */ (`Responsible party unidentified`);
	if (i?.reason === "other") return /** @type {LocalizedString} */ (`Other`);
	return /** @type {LocalizedString} */ (`${i?.reason}`)
	
};

const pt_br2_task_decline_reason_name = /** @type {(inputs: Task_Decline_Reason_NameInputs) => LocalizedString} */ (i) => {
	if (i?.reason === "prior_agreement_or_payment") return /** @type {LocalizedString} */ (`Acordo ou pagamento realizado anteriormente`);
	if (i?.reason === "no_collection_standing") return /** @type {LocalizedString} */ (`Ausência de legitimidade para cobrança`);
	if (i?.reason === "no_causal_link") return /** @type {LocalizedString} */ (`Ausência de nexo causal`);
	if (i?.reason === "concurrent_fault_uncollectible") return /** @type {LocalizedString} */ (`Culpa concorrente`);
	if (i?.reason === "claimant_sole_fault") return /** @type {LocalizedString} */ (`Culpa do requerente`);
	if (i?.reason === "inconclusive_accident_dynamics") return /** @type {LocalizedString} */ (`Dinâmica do sinistro inconclusiva`);
	if (i?.reason === "insufficient_documentation") return /** @type {LocalizedString} */ (`Documentação insuficiente`);
	if (i?.reason === "unproven_damages_or_amounts") return /** @type {LocalizedString} */ (`Impossibilidade de comprovar os danos ou valores reclamados`);
	if (i?.reason === "time_barred") return /** @type {LocalizedString} */ (`Processo prescrito`);
	if (i?.reason === "third_party_liability_unproven") return /** @type {LocalizedString} */ (`Responsabilidade do terceiro não comprovada`);
	if (i?.reason === "responsible_party_unidentified") return /** @type {LocalizedString} */ (`Responsável não identificado`);
	if (i?.reason === "other") return /** @type {LocalizedString} */ (`Outro`);
	return /** @type {LocalizedString} */ (`${i?.reason}`)
	
};

/**
* | reason | output |
* | --- | --- |
* | "prior_agreement_or_payment" | "Agreement or payment made previously" |
* | "no_collection_standing" | "No legal standing to collect" |
* | "no_causal_link" | "No causal link" |
* | "concurrent_fault_uncollectible" | "Concurrent fault" |
* | "claimant_sole_fault" | "Claimant at fault" |
* | "inconclusive_accident_dynamics" | "Inconclusive accident dynamics" |
* | "insufficient_documentation" | "Insufficient documentation" |
* | "unproven_damages_or_amounts" | "Unable to prove the claimed damages or amounts" |
* | "time_barred" | "Statute of limitations expired" |
* | "third_party_liability_unproven" | "Third-party liability unproven" |
* | "responsible_party_unidentified" | "Responsible party unidentified" |
* | "other" | "Other" |
* | * | "{reason}" |
*
* @param {Task_Decline_Reason_NameInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_decline_reason_name = /** @type {((inputs: Task_Decline_Reason_NameInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Decline_Reason_NameInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_decline_reason_name(inputs)
	return pt_br2_task_decline_reason_name(inputs)
});